import { render } from "./Booster.vue?vue&type=template&id=4bbb3e2c"
import script from "./Booster.vue?vue&type=script&lang=js"
export * from "./Booster.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__